import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AnimationService } from '../services/animation.service';

@Directive({
  selector: '[countUp]',
  standalone: true
})
export class CountUpDirective implements OnInit {
  @Input() endValue: number = 0;
  @Input() duration: number = 2000;
  @Input() decimals: number = 0;

  private observer: IntersectionObserver;

  constructor(
    private element: ElementRef,
    private animationService: AnimationService
  ) {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.animationService.animateValue(
            this.element.nativeElement,
            0,
            this.endValue,
            this.duration,
            this.decimals
          );
          this.observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );
  }

  ngOnInit() {
    this.observer.observe(this.element.nativeElement);
  }
}